<template>
	<div class="row justify-content-center no-gutters">
		<div v-bind:class="'col-12 content-heading igrisce-' + grade"  v-html="'Igrišče zgodb <strong>' + grade + '</strong>'" v-if="igrisceLicences.length > 0"></div>
		<template v-if="loaded && igrisceLicences.length > 0">
			<div class="col col-lg-3 col-md-4 col-sm-6 col-12 bralnica-tooltip">
				<div :class="`content-item-wrap ${razred == neaktivenRazred ? 'inactive' : ''}`" v-bind:style="itemStyle" ref="item">
					<a :href="buildBralnicaUrl()" target="_blank">
						<div class="content-item d-flex flex-column h-100">
							<div class="content-icon flex-fill" v-bind:style="{backgroundImage: buildPlaygroundImageUrl()}"></div>
							<div class="content-title content-title-svo">
								<p>Bralnica ustvarjalnica</p>
							</div>
						</div>
					</a>
				</div>
			</div>
			<div v-for="licence in igrisceLicences" class="col col-lg-3 col-md-4 col-sm-6 col-12" :key="licence.creditId">
				<div :class="`content-item-wrap ${[licence.flag]}`" v-bind:style="itemStyle" ref="item">
					<a :href="buildZbirkaDejavnostiUrl(licence)" @click="onClick(licence, false, $event)" target="_blank">
						<div class="content-item d-flex flex-column h-100" :class="licence.credit_id">
							<div class="content-icon flex-fill" v-bind:style="{backgroundImage: iconPath(licence.credit_id)}"></div>
							<div class="content-title content-title-svo" v-if="licence.subtitle">
								<p v-html="licence.subtitle"></p>
							</div>
							<div class="badge" :class="[licence.flag]" v-if="licence.flag"><span v-html="licence.flag_text"></span></div>
						</div>
					</a>
				</div>
			</div>
		</template>

		<div class="col-12 content-heading" v-bind:class="parent.slug" v-html="parent.subtitle" v-if="parent && svoLicences.length > 0" :style="hasMarginTop"></div>
		<template v-if="loaded">
			<div v-for="licence in svoLicences" class="col col-lg-3 col-md-4 col-sm-6 col-12" :key="licence.creditId">
				<div class="content-item-wrap" :class="[licence.flag]"  v-bind:style="itemStyle" ref="item">
					<a :href="buildUrl(licence)" @click="onClick(licence, false, $event)" target="_blank">
						<div class="content-item d-flex flex-column h-100" :class="licence.credit_id">
							<div class="content-icon flex-fill" v-bind:style="{backgroundImage: iconPath(licence.credit_id)}"></div>
							<div class="content-title content-title-svo" v-if="licence.subtitle">
								<p v-html="licence.subtitle"></p>
							</div>
							<div class="badge" :class="[licence.flag]" v-if="licence.flag"><span v-html="licence.flag_text"></span></div>
						</div>
					</a>
				</div>
			</div>
		</template>
		<div v-else class="col col-12">
			<spinner></spinner>
		</div>
	</div>
</template>

<script>
	import libraryItem from '../library-item'

	export default {
		mixins: [libraryItem],
		props: ['slug', 'bralnicaHost'],
		data() {
			return {
				playgroundLicences: ["KNJIZ6DB", "KNJIZ7DB", "KNJIZ8DB", "KNJIZ9DB"],
				redundantLicences: [
					{
						id: "IGZG_SLO8_DnevnikBranja_Delovna",
						razred: 8
					}
				],
				svoLicences: [],
				igrisceLicences: [],
				razred: 6,
				neaktivenRazred: 0
			}
		},
		mounted: function () {
			this.razred = (this.slug.match(/\d+$/) || [])[0];
			this.loadLicences(this.slug, 'order');
		},
		methods: {
			sortLicences(licences) {
				for (let i = 0; i < licences.length; i++) {
					if (this.redundantLicences.find(item => item.id == licences[i].credit_id && item.razred == this.razred)) {
						// do nothing, thus filter out reduntants from svoLicenses
					} else if (this.playgroundLicences.includes(licences[i].credit_id)) {
						this.igrisceLicences.push(licences[i]);

					} else {
						this.svoLicences.push(licences[i]);
					}
				}
			},
			buildPlaygroundImageUrl() {
				const version = new Date().getTime().toString(16);
				if (this.razred == null) {
					return `url(images/icon_${this.playgroundLicences[0]}-bralnica.png?v=${version})`;
				}
				return `url(images/icon_${this.playgroundHashTable["slovenscina-" + this.razred ]}-bralnica.png?v=${version})`;
			},
			buildBralnicaUrl() {
				if (this.razred == this.neaktivenRazred) {
					return "#";
				}
				if (this.razred == null) {
					return `${this.bralnicaHost}/vsebina/${this.razred}`;
				}
				return `${this.bralnicaHost}/vsebina/${this.razred}`;
			},
			buildZbirkaDejavnostiUrl(licence) {
				return this.route('vsebine', licence.credit_id);
			}
		},
		computed: {
			hasMarginTop() {
				if (this.igrisceLicences.length > 0) {
					return {
						marginTop: '30px'
					}
				}
			},
			grade() {
				return parseInt(this.parent.slug.match(/\d+$/)[0], 10);
			},
			playgroundHashTable() {
				// returns { "slovenscina-6": "KNJIZ6DB", ... }
				return this.playgroundLicences.reduce((acc, item, idx) => {
					const key = idx + 6;
					return Object.assign(acc, { ["slovenscina-" + key]: item } );
				}, {});
			}
		},
		watch: {
			loaded() {
				this.sortLicences(this.licences);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/CollectionSlo.vue